import "@hotwired/turbo-rails";
import "./controllers";

import "./initializers/preline";

import { turboDownloadAttachment } from "./application/lib/turbo_download_attachment";
import TurboNativeBridge from "./application/lib/turbo_native_bridge";

import { initPostHog } from "./initializers/posthog";
import "./initializers/local_time";

document.addEventListener("DOMContentLoaded", initPostHog);

window.TurboNativeBridge = TurboNativeBridge;

document.addEventListener("turbo:before-cache", () => {
  window.confirm_modal?.remove();
});

document.addEventListener("turbo:submit-end", turboDownloadAttachment);

window.isApplicationJsLoaded = true;
